import { apiWobaBackend } from "@/services/api-woba-backend";

export function useCalculateInvoicingCompetency() {
  const calculateInvoicingCompetency = async (
    installmentDatesList: string[],
    exceededPaymentDeadline: number,
  ): Promise<
    { installmentDate: string; invoicingCompetencyDate: string }[]
  > => {
    try {
      const response = await apiWobaBackend.get(
        "/payments/invoicing-competency-date",
        {
          params: {
            installmentsDates: installmentDatesList.join(","),
            exceededPaymentDeadline,
          },
        },
      );
      return response.data.invoicingCompetencyDates;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  return {
    calculateInvoicingCompetency,
  };
}
